import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LanguageSwitcher, useT } from "../i18n/index.js";

const HOW_KEYS = ["landing.how1", "landing.how2", "landing.how3"] as const;

export function LandingPage() {
  const t = useT();
  const [code, setCode] = useState("");
  const navigate = useNavigate();

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 6);
    setCode(digits);
    if (digits.length === 6) navigate(`/join/${digits}`);
  };

  const handleJoin = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = code.trim();
    if (/^\d{6}$/.test(trimmed)) navigate(`/join/${trimmed}`);
  };

  return (
    <div className="landing-page">
      <nav className="landing-nav" aria-label={t("landing.siteNavigation")}>
        <Link className="landing-logo" to="/" aria-label={t("landing.home")}>
          HootApp
        </Link>
        <LanguageSwitcher compact />
        <Link className="landing-nav-link" to="/login">
          {t("auth.signIn")}
        </Link>
      </nav>

      <main className="landing-main">
        <section className="landing-hero" aria-labelledby="landing-title">
          <p className="landing-kicker">{t("landing.kicker")}</p>
          <h1 id="landing-title" className="landing-heading">
            {t("landing.title")}
          </h1>
          <p className="landing-tagline">
            {t("landing.tagline")}
          </p>
        </section>

        <div className="landing-cards">
          <section className="landing-join-card" aria-labelledby="landing-join-title">
            <div>
              <h2 id="landing-join-title" className="landing-card-title landing-card-title-inverse">
                {t("landing.joinTitle")}
              </h2>
              <p className="landing-card-sub landing-card-sub-inverse">
                {t("landing.joinSubtitle")}
              </p>
            </div>

            <form onSubmit={handleJoin} className="landing-code-form">
              <label className="landing-code-label" htmlFor="landing-code">
                {t("landing.gameCode")}
              </label>
              <input
                id="landing-code"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                value={code}
                onChange={handleCodeChange}
                placeholder="000000"
                aria-label={t("join.codeAriaLabel")}
                autoComplete="off"
                enterKeyHint="go"
                className="code-input"
              />
              <button type="submit" disabled={code.length !== 6} className="landing-join-button">
                {t("landing.join")}
              </button>
            </form>
          </section>

          <section className="landing-host-card" aria-labelledby="landing-host-title">
            <div>
              <h2 id="landing-host-title" className="landing-card-title">
                {t("landing.createQuiz")}
              </h2>
              <p className="landing-card-sub">{t("landing.createQuizSubtitle")}</p>
            </div>
            <Link to="/login" className="landing-host-button">
              {t("landing.signInToCreate")}
            </Link>
          </section>
        </div>

        <ol className="landing-how-list" aria-label={t("landing.howItWorks")}>
          {HOW_KEYS.map((key, i) => (
            <li key={key} className="landing-how-item">
              <span className="landing-how-num" aria-hidden="true">
                {i + 1}
              </span>
              <p>{t(key)}</p>
            </li>
          ))}
        </ol>
      </main>

      <footer className="landing-footer">
        <span>{t("landing.footer")}</span>
      </footer>
    </div>
  );
}
